<div class="px-6">
  <p class="text-left flex"><yat-icon name="calendar-duo" style="--icon-width: 20px; --icon-height: 20px;" class="-mt-0.5 ml-1 mr-2"></yat-icon> {{ 'checkout.shoppingCart.shoppingCartConfigurator.validFrom' | transloco }}</p>
  <form [formGroup]="shoppingCartConfigurationForm" (yatSubmit)="saveConfiguration($event)" class="text-left mt-4">
    <yat-upcoming-month-selector *ngIf="validityConfigurationOption && validityConfigurationOption?.type === 'UPCOMING_MONTHS'" id="validity-date" formControlName="validityDate" [currentDate]="validityConfigurationOption.currentDate" [includeMonthsAhead]="validityConfigurationOption.months" [includeCurrentMonth]="validityConfigurationOption.includeCurrentMonth" />
    <div class="form-row subscription-cancel-confirm-buttons mt-2">
      <div class="col-12">
      <button
        yat-button
        type="submit"
        class="btn btn-large primary btn w-100"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
        matomoClickAction="Select_ShoppingCartConfiguration">
        <span>{{ ('continue' | commonWording | async) }}</span>
      </button>
      </div>
    </div>
  </form>
</div>
